import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

GoogleAnalytics.initialize('UA-20828736-1', {debug: false});

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    GoogleAnalytics.set({
      page: `/app${page}`,
      ...options,
    });
    GoogleAnalytics.pageview(`/app${page}`);
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      // console.log('componentDidMount - Track Page 1: ' + page);
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      // console.log(currentPage, nextPage);
      if (currentPage !== nextPage) {
        // console.log('componentWillReceiveProps - Track Page 2: ' + nextPage);
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;



// WEBPACK FOOTER //
// ./src/components/withTracker.js